import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@egaranti/components";

import { useTranslation } from "react-i18next";

const DeleteProductConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("productsPage.deleteTitle", "Ürünü silmek istiyor musunuz?")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              "productsPage.deleteDescription",
              "Silinen ürünün QR kodu ve kayıt linki çalışmayacaktır.",
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
          >
            {t("productsPage.delete", "Sil")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteProductConfirmDialog;
